module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"home":"Главная"},"en":{"home":"Home"}}')
  delete Component.options._Ctor
}
